import React from 'react';

import { PortableTextBlock } from '../sanity/portableTextBlock';
import { ImageGallery } from '../media';
import { StandardBlockWrapper } from './standardBlockWrapper';

const ImageText = ({ images, wrapped, padding, imagePosition, backgroundColor, _rawText }) => {
  const imageClasses =
    imagePosition === 'left'
      ? `md:col-end-8 ${wrapped ? 'lg:col-start-3' : 'md:col-start-1'}`
      : `md:col-start-8  ${wrapped ? 'lg:col-end-13' : 'md:col-end-15'}`;

  const textClasses =
    imagePosition === 'left' ? `md:col-start-9 lg:col-end-13` : `md:col-end-7 lg:col-start-3`;

  return (
    <StandardBlockWrapper
      className={`grid grid-cols-14 gap-y-10 md:gap-y-0`}
      padding={padding}
      backgroundColor={backgroundColor}
    >
      <div className={`col-start-2 col-end-14 md:row-start-1 ${imageClasses}`}>
        <ImageGallery items={images} />
      </div>
      <div
        className={`prose md:prose-lg max-w-none col-start-2 col-end-14 md:row-start-1 md:self-center ${textClasses}`}
      >
        <PortableTextBlock text={_rawText} />
      </div>
    </StandardBlockWrapper>
  );
};

export default ImageText;
